import {
  useTheme,
  Box,
  Button,
  Modal as MUIModal,
  Typography,
  IconButton,
} from "@mui/material";
import { Close } from "@mui/icons-material";

const modalStyles = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: { xs: "70vw", sm: 400 },
  bgcolor: "background.paper",
  borderRadius: "20px",
  boxShadow: 24,
  p: 3,
};

const Modal = ({
  open,
  setOpen,
  title,
  confirm,
  children,
  preButtonsComp = null,
  styles = {},
}) => {
  const theme = useTheme();

  const close = (e) => {
    setOpen(false);
    e.stopPropagation();
  };

  return (
    <MUIModal
      open={open}
      onClose={close}
      aria-labelledby={`modal-${title}`}
      onClick={(e) => e.stopPropagation()}
    >
      <Box
        sx={{
          ...modalStyles,
          border:
            theme.palette.mode === "dark"
              ? "2px solid #1e2229"
              : "2px solid #AAB4BE",
          ...styles,
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            width: "100%",
            gap: 2,
          }}
        >
          <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
            <Box sx={{ display: "flex", alignItems: "baseline" }}>
              <Box>
                <Typography variant="h6" component="div">
                  <b>{title}</b>
                </Typography>
              </Box>
              <Box sx={{ marginLeft: "auto" }}>
                <IconButton sx={{ cursor: "pointer" }} onClick={close}>
                  <Close fontSize="small" />
                </IconButton>
              </Box>
            </Box>
            <Box>{children}</Box>
          </Box>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
            }}
          >
            {preButtonsComp}
            <Box sx={{ ml: "auto", display: "flex", gap: 1 }}>
              <ModalButton label="Cancel" onClick={close} />
              <ModalButton
                label="Confirm"
                onClick={confirm}
                variant="contained"
              />
            </Box>
          </Box>
        </Box>
      </Box>
    </MUIModal>
  );
};

const ModalButton = ({ label, onClick, styles = {}, variant = "outlined" }) => {
  return (
    <Button
      variant={variant}
      onClick={onClick}
      sx={{
        textTransform: "none",
        fontWeight: "bold",
        borderRadius: "30px",
        ...styles,
      }}
      size="medium"
    >
      {label}
    </Button>
  );
};

export default Modal;
